import React from 'react';
import { connect } from 'react-redux';
import { FormSpyRenderProps } from 'react-final-form';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { selectVirtualizedTableColumnKeys } from 'services/virtualizedTable/selectors';
import { VirtualizedTableColumnKey } from 'services/virtualizedTable/types';

import VirtualizedTableContext from '../VirtualizedTableContext';
import VirtualizedTableItemValueField from '../VirtualizedTableItemValueField';

interface OwnProps extends FormSpyRenderProps {
    isEditForm?: boolean;
}

interface ConnectedProps {
    columnKeys: ReturnType<typeof selectVirtualizedTableColumnKeys>;
}

type Props = OwnProps & ConnectedProps;

export class VirtualizedTableItemFormFieldsComponent extends React.PureComponent<Props> {
    static contextType = VirtualizedTableContext; // eslint-disable-line

    componentDidUpdate(): void {
        const { hiddenFormFields: getHiddenFormFields } = this.context;
        const { values, form } = this.props;

        if (getHiddenFormFields && form.mutators.unset) {
            const formFields = this.getFormFields();
            const inactiveColumnKeys = Object.keys(values).filter(
                (columnKey: string) =>
                    !['key', 'id'].includes(columnKey) &&
                    !formFields.includes(columnKey)
            );

            if (inactiveColumnKeys.length) {
                form.mutators.unset(inactiveColumnKeys);
            }
        }
    }

    getHiddenFormFields = (): string[] | undefined => {
        const { values } = this.props;
        const { hiddenFormFields } = this.context;

        return hiddenFormFields ? hiddenFormFields(values) : undefined;
    };

    getDisabledFormFields = (): string[] | undefined => {
        const { values } = this.props;
        const { disabledFormFields } = this.context;

        return disabledFormFields ? disabledFormFields(values) : undefined;
    };

    getFormFields = (): VirtualizedTableColumnKey[] => {
        const { columnKeys } = this.props;
        const hiddenFormFields = this.getHiddenFormFields();

        const columns = hiddenFormFields?.length
            ? columnKeys.filter((field) => !hiddenFormFields.includes(field))
            : columnKeys;

        return columns;
    };

    render(): React.ReactElement[] {
        const { isEditForm } = this.props;
        const formFields = this.getFormFields();
        const hiddenFormFields = this.getHiddenFormFields();
        const disabledFormFields = this.getDisabledFormFields();

        return formFields.map((fieldName) => (
            <VirtualizedTableItemValueField
                key={fieldName}
                columnKey={fieldName}
                isEditForm={isEditForm}
                hiddenFormFields={hiddenFormFields}
                disabledFormFields={disabledFormFields}
            />
        ));
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    columnKeys: selectVirtualizedTableColumnKeys
});

export default connect(mapStateToProps)(
    VirtualizedTableItemFormFieldsComponent
);
